import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from 'src/common';
import { ClientListActionTypes, fetchClientList } from 'src/features/clients/list/store/thunks';
import { RootState } from 'src/store';
import { ReportingActionTypes, fetchAfsls } from '../store/thunks';
import { selectScheduler } from './store/selectors';
import { schedulerSlice } from './store/slice';
import {
  SchedulerActionTypes,
  createScheduledEvent,
  fetchAfslTemplates,
  fetchPracticeTemplates,
  fetchScheduledEventById,
  triggerScheduledEvent,
  updateScheduledEvent,
} from './store/thunks';
import { EditScheduledReportComponent } from './components/EditScheduledReportComponent';
import { CreateScheduledReportComponent } from './components/CreateScheduledReportComponent';
import { selectHasClientDirectAccess, selectHasClientEditAdminOnly, selectIsDataFromTriumph } from 'src/store/selectors';
import { selectBulkReporting, selectReportingReports } from '../store/selectors';
import { fetchBenchmarks } from 'src/features/clients/client/performance/store/thunks';
import { fetchRoles, selectPortfoliosWithoutAll, selectRoles } from 'src/features/clients/client/common/store';
import { selectBenchmarks } from 'src/features/clients/client/performance/store/selectors';
import { reportingSlice } from '../store/slice';
import { reportsMapDispatchToProps, reportsMapStateToProps } from 'src/features/clients/client/reportsV2/container';

const mapStateToProps = (state: RootState) => ({
  ...reportsMapStateToProps(state),
  reports: selectReportingReports(state),
  scheduler: selectScheduler(state),
  benchmarks: selectBenchmarks(state),
  bulk: selectBulkReporting(state),
  roles: selectRoles(state),
  clientPortfolios: selectPortfoliosWithoutAll(state),
  isDataFromTriumph: selectIsDataFromTriumph(state),
  hasClientEditAdminOnlyPermission: selectHasClientEditAdminOnly(state),
  hasClientDirectAccess: selectHasClientDirectAccess(state),
  afslsProgress: progressSelectorFactory([ReportingActionTypes.FetchAfsls])(state),
  clientListProgress: progressSelectorFactory([ClientListActionTypes.FetchClientList])(state),
  createScheduledEventProgress: progressSelectorFactory([SchedulerActionTypes.CreateScheduledEvent])(state),
  fetchScheduledEventByIdProgress: progressSelectorFactory([SchedulerActionTypes.GetScheduledEventById])(state),
  updateScheduledEventProgress: progressSelectorFactory([SchedulerActionTypes.UpdateScheduledEvent])(state),
  triggerScheduledEventProgress: progressSelectorFactory([SchedulerActionTypes.TriggerScheduledEvent])(state),
  fetchAfslTemplatesProgress: progressSelectorFactory([SchedulerActionTypes.AfslTemplates])(state),
  fetchPracticeTemplatesProgress: progressSelectorFactory([SchedulerActionTypes.PracticeTemplates])(state),
});

const mapDispatchToProps = {
  ...schedulerSlice.actions,
  ...reportingSlice.actions,
  ...reportsMapDispatchToProps,
  fetchAfsls,
  fetchClientList,
  fetchBenchmarks,
  createScheduledEvent,
  triggerScheduledEvent,
  fetchScheduledEventById,
  updateScheduledEvent,
  fetchAfslTemplates,
  fetchPracticeTemplates,
  fetchRoles,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;

export const EditScheduledReportContainer = connector(EditScheduledReportComponent);
export const CreateScheduledReportContainer = connector(CreateScheduledReportComponent);
